import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import { Form, Icon, Button, Message } from 'semantic-ui-react';
import API from 'utils/api';

class MenuProductCostIngredientsForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      loading: true,
      error: null,
      product: null,
      productId: null
    };
  }

  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.loadProduct);
  }
  
  loadProduct = () => {
    API.getProduct(this.state.productId)
      .then((response) => {
        this.setState({ 
          product: response.data,
          loading: false
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ 
          error: 'Error al cargar el producto',
          loading: false
        });
      });
  }

  render() {
    const formTitle = this.state.product ? `Calcular costo por ingredientes: ${this.state.product.name}` : 'Calcular costo';
    
    if (this.state.loading) {
      return (
        <div>
          <Header text={formTitle} />
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando producto...</p>
          </div>
        </div>
      );
    }
    
    if (!this.state.product) {
      return (
        <div>
          <Header text="Error" />
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            No se encontró el producto
          </div>
          <div style={{ marginTop: '2em' }}>
            <Button 
              fluid 
              onClick={() => this.props.history.push('/menu/products')}
              style={{
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }}
            >
              Regresar
            </Button>
          </div>
        </div>
      );
    }
    
    return (
      <div>
        <Header text={formTitle} />
        
        <Message 
          info
          icon="info circle"
          header="Función en desarrollo"
          content="Esta función para calcular costos basados en ingredientes estará disponible próximamente. Por ahora, puedes usar la opción de costo directo."
          style={{ marginTop: '2em' }}
        />
        
        <div style={{ marginTop: '2em' }}>
          <Button 
            fluid 
            primary
            onClick={() => this.props.history.push(`/menu/products/${this.state.productId}/cost`)}
            style={{
              height: '54px',
              fontSize: '1.1em',
              fontWeight: 'bold',
              boxShadow: 'none',
              borderRadius: '8px',
              marginBottom: '1em'
            }}
          >
            Regresar
          </Button>
        </div>
      </div>
    );
  }
}

export default withRouter(MenuProductCostIngredientsForm); 